module.exports = __webpack_public_path__ + "static/assets/776e172187fe6052c85266436a5c05b5.svg";